<table>
  <thead>
    <tr>
      <th class="col-ref">{{ "LABELS.REF_N" | translate }}</th>
      <th class="col-company">{{ "LABELS.COMPANY" | translate }}</th>
      <th class="col-mbl-hbl">{{ "LABELS.MBL_HBL" | translate }}</th>
      <th class="col-state">{{ "LABELS.STATE" | translate }}</th>
      <th class="col-payment-state">{{ "LABELS.PAYMENT_STATE" | translate }}</th>
      <th class="col-status">{{ "LABELS.STATUS" | translate }}</th>
      <th class="col-date">{{ "LABELS.CREATED" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="totalRows === 0">
      <td colspan="7">
        <div>
          {{ "LABELS.EMPTY_LIST" | translate }}
        </div>
      </td>
    </tr>
    <tr *ngFor="let isf of isfList | async | paginate : { id: tableId, itemsPerPage: limit, currentPage: page, totalItems: total }">
      <td class="col-ref col-mobile-label" [attr.data-label]="'LABELS.REF_N' | translate" [title]="isf.referenceNumber">
        <a [routerLink]="['/isfs-management', isf.id]">{{ isf.referenceNumber }}</a>
      </td>
      <td class="col-company col-mobile-label" [attr.data-label]="'LABELS.COMPANY' | translate" [title]="isf?.company?.name">
        <a *ngIf="showCompanyLink && isf?.company?.id" [routerLink]="['/companies-management', isf?.company?.id]">
          {{ isf.company.name }}
        </a>
        <span *ngIf="!showCompanyLink && isf?.company?.id">
          {{ isf.company.name }}
        </span>
      </td>
      <td
        class="col-mbl-hbl col-mobile-label"
        [attr.data-label]="'LABELS.MBL_HBL' | translate"
        [title]="
          isf.useMasterBillNumber
            ? (isf?.masterBill?.carrier || '') + (isf?.masterBill?.number || '')
            : (isf?.houseBill?.carrier || '') + (isf?.houseBill?.number || '')
        "
      >
        {{
          isf.useMasterBillNumber
            ? (isf?.masterBill?.carrier || "") + (isf?.masterBill?.number || "")
            : (isf?.houseBill?.carrier || "") + (isf?.houseBill?.number || "")
        }}
      </td>
      <td class="col-state col-mobile-label" [attr.data-label]="'LABELS.STATE' | translate" [title]="isf?.state">
        <div *ngIf="isf?.state !== null && isf?.state !== undefined">
          {{ ("STATUS_ISF." + enumIsfState[isf.state] | translate) + " (" + isf.state + ")" }}
        </div>
      </td>
      <td class="col-payment-state col-mobile-label" [attr.data-label]="'LABELS.PAYMENT_STATE' | translate" [title]="isf?.paymentState">
        <bill-status [showValue]="true" [billStatus]="isf.paymentState"></bill-status>
      </td>
      <td class="col-status">
        <div class="d-flex">
          <isf-status [state]="isf.state" [paymentState]="isf.paymentState" [isf]="isf" [showSecondTextForDeleted]="true"></isf-status>
        </div>
      </td>
      <td
        class="col-date col-mobile-label"
        [attr.data-label]="'LABELS.CREATED' | translate"
        [title]="isf.createdDate | customDateTimeByUtc"
      >
        {{ isf.createdDate | customDateTimeByUtc }}
      </td>
    </tr>

    <tr *ngIf="isLoading" class="scrolling-container">
      <th colspan="7">
        <loading-spinner [show]="isLoading"></loading-spinner>
      </th>
    </tr>
  </tbody>

  <tfoot>
    <tr>
      <td [colSpan]="7">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="py-2">
            <ng-template [ngIf]="totalRows">{{ "LABELS.TOTAL_ROWS" | translate }}: {{ totalRows }}/{{ total }}</ng-template>
          </div>
          <div class="py-2 mr-2 d-flex">
            <ng-select
              id="page-limit"
              class="custom"
              [items]="[20, 50, 100]"
              [clearable]="false"
              [ngModel]="limit"
              (ngModelChange)="limitChanged.emit($event)"
            ></ng-select>
            <ng-template [ngIf]="total > limit">
              <pagination-controls
                class="custom-pagination"
                [id]="tableId"
                [maxSize]="paginationMaxSize$ | async"
                [previousLabel]="'LABELS.PREVIOUS' | translate"
                [nextLabel]="'LABELS.NEXT' | translate"
                (pageChange)="onPageChange($event)"
                (pageBoundsCorrection)="onPageChange($event)"
              ></pagination-controls>
            </ng-template>
          </div>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
